import React from 'react';
import Header from "./Header";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
toast.configure();
const Service = () => {
    const handleSubmit = () => {
        toast.success("Product added to cart: Just for Preview");
    };
    return(<div><Header />
        <div className="container"  style={{maxWidth: "110%"}}>
            <h1 style={{position:"relative",paddingTop: "30px",paddingBottom: "30px"}}><center>Search Results on "cake"</center></h1>
            <div className="row row-cols-2 mb-2 ml-2" style={{alignContent: "center", position: "absolute", marginLeft: "10px"}}>
                <div className="card text-white bg-info mb-3 text-center col-xs-6 col-sm-5 col-md-4 col-lg-3 col-xl-2" style={{marginRight:"10px",marginLeft:"10px"}}>
                    <div className="card-header">
                        <span>WHITE FOREST CAKE</span>
                    </div>
                    <img src={process.env.PUBLIC_URL +"/uploads/WhatsApp Image 2020-11-20 at 12.36.18 PM-1605925608148.jpeg"} className="card-img-top" alt="WHITE FOREST CAKE"/>
                    <div className="card-body">
                        <p className="ard-text">taste cake 1kg</p>
                        <p className="card-text">2400</p>
                        <div className="btn-group dropright">
                            <button type="button" className="btn btn-success" data-toggle="modal" onClick={handleSubmit}>
                                <i className="fas fa-shopping-cart" id="cart-logo" data-toggle="modal" data-target="#cart"></i></button>
                                <select className="btn btn-info">
                                    <option disabled="">Quantity</option>
                                    <option value="1">1 Qty</option>
                                    <option value="2">2 Qty</option>
                                    <option value="3">3 Qty</option>
                                    <option value="4">4 Qty</option>
                                    <option value="5">5 Qty</option>
                                    <option value="6">6 Qty</option>
                                </select>
                        </div>
                    </div>
                </div>
                <div className="card text-white bg-info mb-3 text-center col-xs-6 col-sm-5 col-md-4 col-lg-3 col-xl-2" style={{marginRight:"10px",marginLeft:"10px"}}>
                    <div className="card-header">
                        <span>BLACK FOREST CAKE</span>
                    </div>
                    <img src={process.env.PUBLIC_URL +"/uploads/WhatsApp Image 2020-11-20 at 12.38.29 PM (1)-1605925638433.jpeg"} className="card-img-top" alt="BLACK FOREST CAKE"/>
                    <div className="card-body">
                        <p className="ard-text">taste cake 1kg</p>
                        <p className="card-text">2400</p>
                        <div className="btn-group dropright">
                            <button type="button" className="btn btn-success" data-toggle="modal" onClick={handleSubmit}>
                                <i className="fas fa-shopping-cart" id="cart-logo" data-toggle="modal" data-target="#cart"></i>
                            </button>
                            <select className="btn btn-info">
                                <option disabled="">Quantity</option>
                                <option value="1">1 Qty</option>
                                <option value="2">2 Qty</option>
                                <option value="3">3 Qty</option>
                                <option value="4">4 Qty</option>
                                <option value="5">5 Qty</option>
                                <option value="6">6 Qty</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div className="card text-white bg-info mb-3 text-center col-xs-6 col-sm-5 col-md-4 col-lg-3 col-xl-2" style={{marginRight:"10px",marginLeft:"10px"}}>
                    <div className="card-header">
                        <span>BLACK FOREST CAKE</span>
                    </div>
                    <img src={process.env.PUBLIC_URL +"/uploads/WhatsApp Image 2020-11-20 at 12.38.29 PM (1)-1605925894550.jpeg"} className="card-img-top" alt="BLACK FOREST CAKE"/>
                    <div className="card-body">
                        <p className="ard-text">Delicious 1 kg</p>
                        <p className="card-text">2700</p>
                        <div className="btn-group dropright">
                            <button type="button" className="btn btn-success" data-toggle="modal" onClick={handleSubmit}>
                                <i className="fas fa-shopping-cart" id="cart-logo" data-toggle="modal" data-target="#cart"></i>
                            </button>
                            <select className="btn btn-info">
                                <option disabled="">Quantity</option>
                                <option value="1">1 Qty</option>
                                <option value="2">2 Qty</option>
                                <option value="3">3 Qty</option>
                                <option value="4">4 Qty</option>
                                <option value="5">5 Qty</option>
                                <option value="6">6 Qty</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div className="card text-white bg-info mb-3 text-center col-xs-6 col-sm-5 col-md-4 col-lg-3 col-xl-2" style={{marginRight:"10px",marginLeft:"10px"}}>
                    <div className="card-header">
                        <span>BUTTERCREAM LAYER</span>
                    </div>
                    <img src={process.env.PUBLIC_URL +"/uploads/WhatsApp Image 2020-11-20 at 1.01.03 PM-1605925946700.jpeg"} className="card-img-top" alt="BUTTERCREAM LAYER"/>
                    <div className="card-body">
                        <p className="ard-text">Delicious cake 1kg</p>
                        <p className="card-text">2700</p>
                        <div className="btn-group dropright">
                            <button type="button" className="btn btn-success" data-toggle="modal" onClick={handleSubmit}>
                                <i className="fas fa-shopping-cart" id="cart-logo" data-toggle="modal" data-target="#cart"></i>
                            </button>
                            <select className="btn btn-info">
                                <option disabled="">Quantity</option>
                                <option value="1">1 Qty</option>
                                <option value="2">2 Qty</option>
                                <option value="3">3 Qty</option>
                                <option value="4">4 Qty</option>
                                <option value="5">5 Qty</option>
                                <option value="6">6 Qty</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div className="card text-white bg-info mb-3 text-center col-xs-6 col-sm-5 col-md-4 col-lg-3 col-xl-2" style={{marginRight:"10px",marginLeft:"10px"}}>
                    <div className="card-header">
                        <span>OLD FASHIONED CHOCOLATE</span>
                    </div>
                    <img src={process.env.PUBLIC_URL +"/uploads/WhatsApp Image 2020-11-20 at 1.00.59 PM-1605925953982.jpeg"} className="card-img-top" alt="OLD FASHIONED CHOCOLATE"/>
                    <div className="card-body">
                        <p className="ard-text">Delicious cake 1kg</p>
                        <p className="card-text">2700</p>
                        <div className="btn-group dropright">
                            <button type="button" className="btn btn-success" data-toggle="modal" onClick={handleSubmit}>
                                <i className="fas fa-shopping-cart" id="cart-logo" data-toggle="modal" data-target="#cart"></i>
                            </button>
                            <select className="btn btn-info">
                                <option disabled="">Quantity</option>
                                <option value="1">1 Qty</option>
                                <option value="2">2 Qty</option>
                                <option value="3">3 Qty</option>
                                <option value="4">4 Qty</option>
                                <option value="5">5 Qty</option>
                                <option value="6">6 Qty</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div className="card text-white bg-info mb-3 text-center col-xs-6 col-sm-5 col-md-4 col-lg-3 col-xl-2" style={{marginRight:"10px",marginLeft:"10px"}}>
                    <div className="card-header">
                        <span>CAKE ORDERS</span>
                    </div>
                    <img src={process.env.PUBLIC_URL +"/uploads/c4385a8bf3618320e4a1df86a2ded4b4--purple-bridal-showers-wedding-showers-1606917516544.jpg"} className="card-img-top" alt="CAKE ORDERS"/>
                    <div className="card-body">
                        <p className="ard-text">All cakes within half hour ....200-1500 RS</p>
                        <p className="card-text">4500</p>
                        <div className="btn-group dropright">
                            <button type="button" className="btn btn-success" data-toggle="modal" onClick={handleSubmit}>
                                <i className="fas fa-shopping-cart" id="cart-logo" data-toggle="modal" data-target="#cart"></i>
                            </button>
                            <select className="btn btn-info">
                                <option disabled="">Quantity</option>
                                <option value="1">1 Qty</option>
                                <option value="2">2 Qty</option>
                                <option value="3">3 Qty</option>
                                <option value="4">4 Qty</option>
                                <option value="5">5 Qty</option>
                                <option value="6">6 Qty</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
};

export default Service;